import { Loader } from "@googlemaps/js-api-loader";

const Map = (() => {
  const DOM = {};

  const cacheDOM = () => {
    DOM.map = document.getElementById("map");
  };

  const buildMap = () => {
    const loader = new Loader({
      apiKey: GOOGLE_MAPS_API_LIVE_KEY,
      version: "weekly",
    });

    const lat = parseFloat(DOM.map.dataset.lat);
    const lng = parseFloat(DOM.map.dataset.lng);
    const mapId = DOM.map.dataset.id;

    let map;

    loader.load().then(async () => {
      const { Map } = await google.maps.importLibrary("maps");
      const { AdvancedMarkerElement } = await google.maps.importLibrary(
        "marker"
      );

      map = new Map(document.getElementById("map"), {
        center: { lat, lng },
        zoom: 16,
        styles: [
          {
            featureType: "administrative",
            elementType: "all",
            stylers: [{ saturation: "-100" }],
          },
          {
            featureType: "administrative.province",
            elementType: "all",
            stylers: [{ visibility: "off" }],
          },
          {
            featureType: "landscape",
            elementType: "all",
            stylers: [
              { saturation: -100 },
              { lightness: 65 },
              { visibility: "on" },
            ],
          },
          {
            featureType: "poi",
            elementType: "all",
            stylers: [
              { saturation: -100 },
              { lightness: "50" },
              { visibility: "simplified" },
            ],
          },
          {
            featureType: "road",
            elementType: "all",
            stylers: [{ saturation: "-100" }],
          },
          {
            featureType: "road.highway",
            elementType: "all",
            stylers: [{ visibility: "simplified" }],
          },
          {
            featureType: "road.arterial",
            elementType: "all",
            stylers: [{ lightness: "30" }],
          },
          {
            featureType: "road.local",
            elementType: "all",
            stylers: [{ lightness: "40" }],
          },
          {
            featureType: "transit",
            elementType: "all",
            stylers: [{ saturation: -100 }, { visibility: "simplified" }],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              { hue: "#ffff00" },
              { lightness: -25 },
              { saturation: -97 },
            ],
          },
          {
            featureType: "water",
            elementType: "labels",
            stylers: [{ lightness: -25 }, { saturation: -100 }],
          },
        ],
        // mapId: mapId,
        gestureHandling: "none",
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
      });

      const parser = new DOMParser();
      // A marker with a custom inline SVG.
      const pinSvgString =
        '<svg xmlns="http://www.w3.org/2000/svg" width="52.141" height="17.788" viewBox="0 0 52.141 17.788"><g id="Group_80" data-name="Group 80" transform="translate(-773 -966.724)"><g id="Group_79" data-name="Group 79"><g id="Group_78" data-name="Group 78"><g id="Group_77" data-name="Group 77"><g id="Group_76" data-name="Group 76"><path id="Path_163" data-name="Path 163" d="M782.361,971.1v13.12h-4.546V971.1H773v-4.078h14.176V971.1Z" fill="#22243c"/><path id="Path_164" data-name="Path 164" d="M825.141,980.974a8.111,8.111,0,0,1-7.027,3.538,8.9,8.9,0,1,1-.049-17.788c2.85,0,5.331,1.007,6.732,3.169l-3.637,2.334a3.653,3.653,0,0,0-2.948-1.424c-2.579,0-4.5,1.867-4.5,4.815s1.941,4.815,4.4,4.815a3.938,3.938,0,0,0,3.317-1.719Z" fill="#22243c"/></g></g><path id="Path_165" data-name="Path 165" d="M806.9,979.864c-.25.849-.724,1.723-1.773,1.723-.9,0-1.9-1.085-3.525-3.314-.136-.185-.275-.379-.419-.581a14,14,0,0,1,.834-1.3,5.557,5.557,0,0,1,4.348-1.956v-.462l-6.241-.005v.447c.933.328,1.742,1.236,1.247,2.025l-.536.807-.378-.512-2.868-3.881a3.539,3.539,0,0,0,2.172-3.1c0-2.1-1.822-2.92-3.544-2.92-2.3,0-4.619,1.423-4.619,3.944a6.717,6.717,0,0,0,1.747,4.094c-2.047,1.049-4.443,3.1-4.443,5.593a3.932,3.932,0,0,0,3.869,3.919,6.71,6.71,0,0,0,5.467-2.871c1.2,1.472,2.347,2.871,4.444,2.871,2.322,0,4.194-2.347,4.719-4.344Zm-9.736-12.257a2.163,2.163,0,0,1,2.122,2.172,3.261,3.261,0,0,1-1.972,2.7c-1.273-1.7-1.973-2.8-1.973-3.4C795.337,968.256,795.887,967.607,797.16,967.607Zm-1.048,14.429c-1.4,0-3.771-3.37-3.771-4.917,0-.975.525-1.374,1.224-1.848l4.394,5.841A2.391,2.391,0,0,1,796.112,982.036Z" fill="#22243c"/></g></g></g></svg>';
      const pinSvg = parser.parseFromString(
        pinSvgString,
        "image/svg+xml"
      ).documentElement;

      //   // The marker, positioned at Uluru
      //   new AdvancedMarkerElement({
      //     map: map,
      //     position: { lat, lng },
      //     content: pinSvg,
      //     title: "Town & Country Nannies",
      //   });

      new google.maps.Marker({
        position: { lat, lng },
        map,
        // icon: pinSvg,
        icon: "../dist/images/svg/map-icon.svg",
        title: "Town & Country Nannies",
      });
    });
  };

  const init = () => {
    cacheDOM();

    if (DOM.map) {
      buildMap();
    }
  };

  return {
    init,
  };
})();

export default Map;
